import { useMutation, useQueryClient } from '@tanstack/react-query'
import { editBillRate } from 'api/billRates/editBillRate'
import { billRatesKey } from './keys'

export const useEditBillRateMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: Parameters<typeof editBillRate>[0]) =>
      editBillRate(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: billRatesKey })
    },
  })
}
